module.exports = __webpack_public_path__ + "img/icon-device.fe1c76f8.svg";